import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export interface ImpersonationBannerViewProps {
    name: string;
    onStop: () => void;
    stopping: boolean;
}

/**
 * Reine Darstellung der Warnleiste (ohne Router/Hooks → in Jest testbar). Zeigt
 * den Namen des imitierten Benutzers und einen Beenden-Button; fixiert am oberen
 * Rand, als Warnhinweis erkennbar, mobiltauglich (flexWrap).
 */
export const ImpersonationBannerView: React.FC<ImpersonationBannerViewProps> = ({ name, onStop, stopping }) => (
    <Box
        role="alert"
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.drawer + 2,
            width: '100%',
            backgroundColor: 'var(--pvta-danger, #b3261e)',
            color: '#fff',
            px: { xs: 1.5, md: 3 },
            py: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: { xs: 1, md: 2 },
            flexWrap: 'wrap',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        }}
    >
        <WarningAmberIcon fontSize="small" />
        <Typography sx={{ fontWeight: 700, fontSize: { xs: '0.85rem', md: '0.95rem' } }}>
            Achtung: Sie imitieren gerade {name}.
        </Typography>
        <Button
            onClick={onStop}
            disabled={stopping}
            size="small"
            variant="contained"
            sx={{
                backgroundColor: '#fff',
                color: 'var(--pvta-danger, #b3261e)',
                fontWeight: 700,
                borderRadius: 999,
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.88)' },
            }}
        >
            Impersonation beenden
        </Button>
    </Box>
);

export default ImpersonationBannerView;
